import type { ClientSuppliedConfig } from '@ms/yammer-telemetry-support';

import type { SessionConfig } from './session/types';

export interface Config extends SessionConfig {
  readonly telemetry: ClientSuppliedConfig;
}

export const getStaticConfig = (): Config => (typeof window !== 'undefined' ? window.__yammerconfig__ : {}) as Config;
